import { Navigate, useNavigate } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { ProfileSetup } from "../../components/ProfileSetup";
import { usePlatformAuth } from "../../lib/use-platform-auth";

export function ProfileSetupPage() {
  const navigate = useNavigate();
  const {
    sessionData,
    isPending,
    bootstrapLoading,
    profileSetupGateReady,
    profile,
    passkeyCount,
    setupIncomplete,
    defaultOrganization,
    deferProfileSetup,
    clearDeferredProfileSetup,
    refresh,
  } = usePlatformAuth();

  if (isPending || (sessionData?.user && (!profileSetupGateReady || (bootstrapLoading && !profile)))) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <LoaderCircle className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!sessionData?.user) {
    return <Navigate to="/auth/login" replace />;
  }

  if (profile && !setupIncomplete) {
    clearDeferredProfileSetup();
    return <Navigate to={defaultOrganization ? `/${defaultOrganization.slug}` : "/"} replace />;
  }

  if (!profile) {
    return null;
  }

  return (
    <ProfileSetup
      profile={profile}
      passkeyCount={passkeyCount}
      onProfileRefresh={refresh}
      onDefer={deferProfileSetup}
      onComplete={async () => {
        await refresh();
        navigate(defaultOrganization ? `/${defaultOrganization.slug}` : "/", { replace: true });
      }}
    />
  );
}
